//window.baseURL = 'http://127.0.0.1/api/';
//window.baseURL = 'http://104.248.251.33:9080/api/';
window.baseURL = 'https://api.cnhu-consult.gouv.bj/api/';

import axios from 'axios'
//import auth from '@/helper/auth'

//let bearToken = auth.getSession();

const config = {
  baseURL: window.baseURL,
  //timeout: 720 * 1000
}
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

export default axios.create(config);
